/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtCreateDto } from '../../models/ddt-create-dto';
import { DdtItem } from '../../models/ddt-item';

export interface DdtControllerCreate$Params {
      body: DdtCreateDto
}

export function ddtControllerCreate(http: HttpClient, rootUrl: string, params: DdtControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtItem;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtItem;
      }>;
    })
  );
}

ddtControllerCreate.PATH = '/ddt';
